import { Component } from '@angular/core';

@Component({
  selector: 'lfx-project-not-found',
  standalone: true,
  imports: [],
  templateUrl: './project-not-found.component.html',
  styleUrl: './project-not-found.component.scss',
})
export class ProjectNotFoundComponent {}
